import { ReactElement } from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import styled from 'styled-components'

import { ErrorMessage } from 'components/v2/ErrorMessage'
import Heading from 'components/v2/Heading'
import { Radio } from 'components/v2/Radio'
import { ISelectActivePeriodProps } from './types'

const ACTIVE_PERIOD_LIST = process.env.SERVICE_ACTIVE_PERIODS?.split(',') || ['4', '60', '90', '120']

const activePeriodMessages = defineMessages({
  value: {
    id: 'activePeriod.value.dynamic',
    defaultMessage: '{activePeriod} days'
  }
})

const SelectActivePeriodContainer = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 64px;
  row-gap: 16px;
`

const ActivePeriodOptions = styled.div`
  align-items: center;
  display: flex;
  gap: 16px 50px;
  flex-wrap: wrap;
`

const SelectActivePeriod = ({ value, touched, errors, onChange, disabled }: ISelectActivePeriodProps): ReactElement => {
  const intl = useIntl()
  const showError = touched && Boolean(errors)

  const handleActivePeriodChange = ({ target: { id: activePeriod } }: React.ChangeEvent<HTMLInputElement>): void => {
    onChange(activePeriod)
  }

  return (
    <SelectActivePeriodContainer>
      <Heading.Label>
        <FormattedMessage id="form.activePeriod.label" defaultMessage="Active Period" />
      </Heading.Label>
      <ActivePeriodOptions>
        {ACTIVE_PERIOD_LIST.map((activePeriod: TSFixMe) => {
          return (
            <Radio
              id={activePeriod}
              key={activePeriod}
              name="activePeriod"
              checked={value === activePeriod}
              onChange={handleActivePeriodChange}
              disabled={disabled}
            >
              {intl.formatMessage(activePeriodMessages.value, { activePeriod })}
            </Radio>
          )
        })}
      </ActivePeriodOptions>
      {showError && <ErrorMessage>{errors}</ErrorMessage>}
    </SelectActivePeriodContainer>
  )
}

export { SelectActivePeriod }
